module.exports = __webpack_public_path__ + "img/icons.9acbc91f.svg";